export async function getFullPost(_, postName: string, type: string) {
  try {
    const response = await fetch(`/api/post?type=${type}&postName=${postName}`);
    const data = await response.json();
    return data;
  } catch (err) {
    console.error(err);
  }
}
